import { LazyAction, LazyModule } from 'owa-bundling';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { SaveReadingPaneOptionState } from './actions/saveReadingPaneOption';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Options" */ './lazyIndex'));

// export types
export {
    SaveReadingPanePositionOptionStitchName,
    SaveReadingPanePositionOptionStitch,
} from './actions/saveReadingPaneOption';
export { ReadingPanePosition, SaveReadingPaneOptionState };

export let lazySaveReadingPaneOption = new LazyAction(
    lazyModule,
    m => m.saveReadingPaneOptionQuick
);
